// extracted by mini-css-extract-plugin
export var collapsedSummary = "_li-0";